import { motion } from 'framer-motion';
import { Send } from 'lucide-react';

// Custom X (Twitter) icon component - the new X logo
const XIcon = ({ size = 16 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

// Custom TikTok icon - musical note style resembling the TikTok logo
const TikTokIcon = ({ size = 16 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const SOCIALS = [
  {
    icon: <Send size={16} />,
    label: 'TELEGRAM',
    href: 'https://t.me/ZatoUK',
    handle: 't.me/ZatoUK',
  },
  {
    icon: <XIcon size={16} />,
    label: 'X / TWITTER',
    href: 'https://x.com/Zato_UK',
    handle: '@Zato_UK',
  },
  {
    icon: <TikTokIcon size={16} />,
    label: 'TIKTOK',
    href: 'https://tiktok.com/@Zato_UK',
    handle: '@Zato_UK',
  },
];

export function Footer() {
  return (
    <footer className="relative py-24 px-6 overflow-hidden border-t border-white/10" data-testid="site-footer">
      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="md:col-span-2">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="footer-brand"
              data-testid="footer-brand"
            >
              ZATO
            </motion.h2>
            <p className="font-mono text-xs text-white/50 mt-4 max-w-sm leading-relaxed" data-testid="footer-tagline">
              // ANONYMOUS | PRIVATE | OFF-THE-GRID<br />
              // THE OBJECT EXISTS. THE IDENTITY DOES NOT.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs text-white/60 mb-6 tracking-widest">SECURE_CHANNELS</p>
            <div className="space-y-4" data-testid="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
                >
                  <span className="social-icon">{s.icon}</span>
                  <div>
                    <div className="social-label">{s.label}</div>
                    <div className="social-handle">{s.handle}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono text-xs text-white/50" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} ZATO — ALL RIGHTS RESERVED
          </p>
          <p className="font-mono text-xs text-white/40">
            // BUILT OFF-THE-GRID — NO TRACKERS — NO SURVEILLANCE
          </p>
        </div>
      </div>
    </footer>
  );
}
